module.exports = __webpack_public_path__ + "img/z1.2c6e45e1.jpg";